import React, { useEffect } from 'react'

// import {
//   BrowserRouter as Router,
// } from "react-router-dom";
import {
  Routes,
  Route,
} from "react-router-dom";
import { ROUTES, history } from './history';
import { BrowserRouter as Router } from './BrowserRouter';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AdapterDayjs from '@mui/lab/AdapterDayjs';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from "react-redux";
import { useDispatch } from "react-redux";
// import Auth from './pages/Auth';
import { QueryClientProvider } from 'react-query'
 
import LandingPage from './modules/app/components';
import { initAction } from './modules/app/store/actions';

import Box from '@mui/system/Box';
import AdminRoutes from './modules/admin';
import Auth from './modules/auth';
import func from './store';
import ErrorReporter from './components/ErrorReporter';
import GeneralRoutes from './modules/general';
import queryClient from './queryClient';


const { store, persistor } = func();





const theme = createTheme({
  typography: {
    fontFamily: [
      'Lato', 'sans-serif'
    ].join(','),
  },
})




function MainRoutes() {

  return (
    <Routes>
      <Route path="/" element={<LandingPage/>} />
      <Route path="/general/*" element={<GeneralRoutes />} />
      <Route path={ROUTES.ADMIN_AUTH} element={<Auth />} />
      <Route path={ROUTES.CONTRACTOR_AUTH} element={<Auth />} />
      <Route path="admin/*" element={<AdminRoutes />} />
    
    </Routes>
  )
}

// function ContractorRoutes() {

//   return (
//     <Routes>
//       <Route path="/" element={<LandingPage/>} />
//       <Route path={ROUTES.ADMIN_AUTH} element={<Auth />} />
//       <Route path={ROUTES.CONTRACTOR_AUTH} element={<Auth />} />
//       <Route path="admin/*" element={<AdminRoutes />} />
    
//     </Routes>
//   )
// }

function MedAppAdminApp() {

  // const [loading, setLoading] = React.useState(true)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initAction.request());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return (
    <Box
      sx={{
        bgcolor: "background.default",
        minHeight: "100vh",
        color: "text.primary",
      }}
    >
      <MainRoutes />
      {/* {loading ? <LoadingPageIndicator /> : <DefRoutes /> }
      <
      <ApiLoader setLoading={setLoading} request={getUser} onLoad={() => console.log('loaded')} /> */}
      <ErrorReporter />
    </Box>

  );

}


function App() {
  return (
    <main className="App">

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <Router navigator={history}>
                <MedAppAdminApp />
              </Router>
              </QueryClientProvider>
            </PersistGate>
          </Provider>
        </ThemeProvider>

      </LocalizationProvider>
    </main>
  );
}

export default App;
